import React from 'react';
import { CnBox } from '@cainiaofe/cn-ui';
import { initArray } from '@/lowcode/common/util/util';


const CnSkeleton = window.CNUIM?.CnSkeleton;

export default function Skeleton({
  flexLayoutConfig,
  contentLength,
}: {
  // layout?: 'flex';
  flexLayoutConfig: {
    columnGap: number;
    rowGap: number;
    columns: number;
  };
  contentLength: number;
}) {
  if (!CnSkeleton) {
    return null;
  }
  const length = contentLength;

  const { columnGap, rowGap, columns } = flexLayoutConfig;
  const rowCount = Math.ceil(length / columns);
  const rows = initArray(rowCount);
  const datas = initArray(length);

  return (
    <CnBox spacing={rowGap}>
      {rows.map((index) => {
        return (
          <CnBox spacing={columnGap} direction="row" key={index} style={{ overflow: 'auto' }}>
            {datas
              .filter((item, idx) => idx >= index * columns && idx < index * columns + columns)
              .map(() => {
                return (
                  <div
                    className="cn-statistic-card-list-item"
                    style={{
                      flexGrow: 0,
                      width: `calc((100% - ${columnGap * (columns - 1)}px)/${columns})`,
                    }}
                  >
                    <CnSkeleton className="d" style={{ width: '100%' }}>
                      <CnSkeleton.Title animated />
                      <CnSkeleton.Paragraph lineCount={2} animated />
                    </CnSkeleton>
                  </div>
                );
              })}
          </CnBox>
        );
      })}
    </CnBox>
  );
}
